import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { getSite, getLinks, getSections } from "./api";

const DEFAULTS = {
  general: { brand_name: "Rada Collab", tagline: "Crafted for Impact", contact_email: "hello@radacollab.com" },
  hero: {},
  campaign: {},
  problems: {},
  shift: {},
  services: {},
  booking: {},
  footer: {},
  modal: {},
};

const Ctx = createContext({ site: DEFAULTS, links: [], sections: [], loading: true });

export const SiteProvider = ({ children }) => {
  const [site, setSite] = useState(DEFAULTS);
  const [links, setLinks] = useState([]);
  const [sections, setSections] = useState([]);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const [s, l, sec] = await Promise.all([getSite(), getLinks(), getSections()]);
      setSite({ ...DEFAULTS, ...s });
      setLinks(l);
      setSections(sec);
    } catch {
      // keep defaults
    }
    setLoading(false);
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return <Ctx.Provider value={{ site, links, sections, loading, refresh }}>{children}</Ctx.Provider>;
};

export const useSite = () => useContext(Ctx);

// Helper: get a content value with fallback
export const t = (site, path, fallback) => {
  const v = path.split(".").reduce((o, k) => (o && o[k] !== undefined ? o[k] : undefined), site);
  return v === undefined || v === null || v === "" ? fallback : v;
};
